module.exports = __webpack_public_path__ + "static/media/resumeWork.911dcdd9.jpg";